import logging from '~/stores/providers/logging';

export const letsDooray = () => {
  const primary = 'color:#4757c4;font-size:11px;';
  const white = 'font-size:11px;';
  const gray = 'color:#888;font-size:11px;';

  logging.log(
    // eslint-disable-next-line no-multi-str
    "%c _            _    _       %c ______                                    _ \
    \n%c| |          | |  ( )       %c|  _  \\                                  | |\
    \n%c| |      ___ | |_ |/  ___   %c| | | |  ___    ___   _ __   __ _  _   _ | |\
    \n%c| |     / _ \\| __|   / __|  %c| | | | / _ \\  / _ \\ | '__| / _` || | | || |\
    \n%c| |____|  __/| |_    \\__ \\  %c| |/ / | (_) || (_) || |   | (_| || |_| ||_|\
    \n%c\\_____/ \\___| \\__|   |___/  %c|___/   \\___/  \\___/ |_|    \\__,_| \\__, |(_)\
    \n                                                                __/ |   \
    \n                                                               |___/ \
    \n\
    \n\
    \n                                         %cAll in One collaboration tools.\
    \n\
    \n\
    ",
    white,
    primary,
    white,
    primary,
    white,
    primary,
    white,
    primary,
    white,
    primary,
    white,
    primary,
    gray
  );
};
